import { CSSProperties, ReactNode } from 'react';

type EmptyStateBoxProps = {
	title: string;
	description?: string;
	icon?: ReactNode;
	/** Variante compacta para celdas de tabla u espacios reducidos */
	subtle?: boolean;
	/** Variante aún más densa, en línea (ideal para celdas) */
	compact?: boolean;
	style?: CSSProperties;
};

export const EmptyStateBox = ({ title, description, icon, subtle, compact, style }: EmptyStateBoxProps) => {
	if (compact) {
		return (
			<div
				style={{
					display: 'inline-flex',
					alignItems: 'flex-start',
					gap: 8,
					padding: '6px 10px',
					background: '#f8fafc',
					border: '1px dashed #dde3ea',
					borderRadius: 6,
					color: 'LightSlateGray',
					maxWidth: '100%',
					...style,
				}}
			>
				{icon ? (
					<span style={{ fontSize: 13, color: '#94a3b8', lineHeight: 1.2, flexShrink: 0, marginTop: 1 }}>
						{icon}
					</span>
				) : null}
				<div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 0 }}>
					<span style={{ fontSize: 12, fontWeight: 600, lineHeight: 1.2 }}>{title}</span>
					{description ? (
						<span style={{ fontSize: 11, opacity: 0.8, lineHeight: 1.2 }}>{description}</span>
					) : null}
				</div>
			</div>
		);
	}

	return (
		<div
			style={{
				padding: subtle ? '10px 12px' : '48px 24px',
				textAlign: 'center',
				background: subtle ? '#f8fafc' : '#F4F7FA',
				border: `1px dashed ${subtle ? '#dde3ea' : '#c5cdd6'}`,
				borderRadius: subtle ? 8 : 12,
				color: 'LightSlateGray',
				...style,
			}}
		>
			{icon ? (
				<div style={{
					fontSize: subtle ? 16 : 28,
					marginBottom: subtle ? 4 : 12,
					color: '#94a3b8',
				}}>
					{icon}
				</div>
			) : null}
			<div style={{ fontSize: subtle ? 12 : 16, fontWeight: 600 }}>{title}</div>
			{description ? (
				<div style={{ fontSize: subtle ? 11 : 13, marginTop: subtle ? 2 : 6, opacity: subtle ? 0.85 : 1 }}>
					{description}
				</div>
			) : null}
		</div>
	);
};
